let PACKAGE = {
  PACKAGE_IDS: {
    COURSE_PLANNING: 'PKG_COURSE_PLANNING_001',
    EXPLORE: 'PKG_EXPLORE_001',
    EXTERNAL_COURSES: 'PKG_EXTERNAL_COURSES_001',
    DASHBOARD: 'PKG_DASHBOARD_001',
    CLEARLY_NEXT: 'PKG_CLEARLY_NEXT_001',
    MARKETPLACE: 'PKG_MARKETPLACE_001'
  },
  FEATURE_IDS: {
    SHOW_RESOURCE_RATING : 'resource_rating',
    USE_DIV_FOR_PDF : 'Use Div For PDF',
    STUDENT_DASHBOARD_FEATURE_ID: 'student_dashboard',
    PROFILE_FEATURE_ID: 'Profile_Pop_up',
    TOUR_FEATURE_ID: 'tour',
    LEGEND_FEATURE_ID: 'legend',
    STUDENT_PROGRESS_FEATURE_ID: 'student_progress',
    ENROLLED_COURSES_FEATURE_ID: 'enrolled_courses',
    RECOMMENDATIONS_FEATURE_ID: 'recommendations',
    STREAM_RECOMMENDATIONS_FEATURE_ID: 'stream_recommendations',
    QUICK_LINKS_FEATURE_ID: 'quick_links',
    URGENT_NOTIFICATIONS_FEATURE_ID: 'urgent_notifications',
    ADVISTOR_DASHBOARD_FEATURE_ID: 'advisor_dashboard',
    CHANNELS_FEATURE_ID: 'channels',
    TIME_VIEW_FEATURE_ID: 'time_view',
    PROGRESS_VIEW_FEATURE_ID: 'progress_view',
    CATEGORY_VIEW_FEATURE_ID: 'category_view',
    REPORTS_VIEW_FEATURE_ID: 'reports_view',
    MASTER_SEARCH_FEATURE_ID: 'all_search',
    COURSE_SEARCH_FEATURE_ID: 'course_search',
    CATALOG_SEARCH_FEATURE_ID: 'catalog_search',
    TAG_SEARCH_FEATURE_ID: 'tag_search',
    SHARING_FEATURE_ID: 'sharing',
    ADD_TO_STREAM_FEATURE_ID: 'add_to_stream',
    SCHEDULE_CHECK_FEATURE_ID: 'schedule_check',
    PRE_REQ_FEATURE_ID: 'pre_req_check',
    PLANNER_VIEW_FEATURE_ID: 'planner_view',
    PLAN_STREAM_FEATURE_ID: 'plan_stream',
    PLAN_STREAM_CATALOGS_FEATURE_ID: 'plan_stream_catalogs',
    PLAN_STREAM_OTHER_ENTITIES_FEATURE_ID: 'plan_stream_other_entities',
    CLEARLY_NEXT_FEATURE_ID: 'clearly_next',
    UNMUDL_FEATURE_ID: 'unmudl',
    EXPLORE_INSIGHTS: 'explore_insights',
    ACADEMIC_ALUMNI_INSIGHTS_FEATURE_ID: 'Academic_Alumni_Insights',
    BACKGROUND_ALUMNI_INSIGHTS_FEATURE_ID: 'Background_Alumni_Insights',
    CAREER_ALUMNI_INSIGHTS_FEATURE_ID: 'Career_Alumni_Insights',
    PIVOTS_FEATURE_ID: 'Pivots',
    EXPLORE_FEATURE_ID: 'explore',
    BOOKMARK_FEATURE_ID: 'showBookmark',
    EXPLORE_SEARCH_FEATURE_ID: 'explore_search',
    EXPLORE_SEARCH_EMSI_SOURCE: 'EMSI',
    EXPLORE_SEARCH_BGT_SOURCE: 'BGT',
    EXPLORE_SEARCH_LIGHTCAST_SOURCE: 'LIGHTCAST',
    SHOW_CITY_STATE_FILTER_ON_WIDGET: 'showCityStateFilterOnWidget',
    UNLOCK_COMPANIES_SKILLS_ON_WIDGET: 'unlockCompaniesSkillsOnWidget',
    EXPLORE_PROGRAMS: 'explore_programs',
    EXPLORE_PROGRAM_DETAIL: 'explore_program_detail',
    EXPLORE_CAREERS: 'explore_careers',
    EXPLORE_CAREER_DETAIL: 'explore_career_detail',
    EXPLORE_PROGRAM_CUSTOM_TAGS_FEATURE_ID: 'explore_program_custom_tags',
    CHANNEL_CAN_SEND_FEATURE_ID: 'Can_Send_Messages',
    CHANNEL_SHOW_URGENT_NOTIFICATIONS_TAG: 'show_urgent_notifications_tag',
    CHANNEL_SHOW_MESSAGE_TIMESTAMP: 'show_message_timestamp',
    ZENDESK_FEATURE_ID: 'zendesk',
    STREAM_EXPORT: 'stream_export',
    EXCLUDED_COURSES_FEATURE_ID: 'excluded_courses',
    SKILL_TAGGING_FEATURE_ID: 'skill_tagging',
    SKILL_TAGGING_LEVELS_FEATURE_ID: 'skill_tagging_levels',
    SKILL_TAGGING_SOURCE_FEATURE_ID: 'skill_tagging_source',
    OTHER_SKILL_TAGGING_SOURCE_FEATURE_ID: 'other_skill_tagging_source',
    SEND_PROGRESS_EMAIL: 'send_progress_email',
    SHOW_CATEGORY_AS_SEPARATE_DROPDOWN: 'showCategoryAsSeparateDropdownOnWidget',
    SHOW_SELECT_PROGRAM_MESSAGE: 'showSelectProgramMessageOnWidget',
    CUSTOM_CSS_ON_WIDGET: 'customCSSOnWidget',
    SHOW_PHONE_NUMBER_ON_WIDGET: 'showPhoneNumberOnWidget',
    SHOW_EDUCATION_LEVEL: 'showEducationLevel',
    SHOW_EDUCATION_LEVEL_ON_WIDGET: 'showEducationLevelOnWidget',
    SHOW_TERM_ON_WIDGET: 'showTermOnWidget',
    CUSTOM_CREDIT_LABEL_FEATURE_ID: 'custom_credit_label',
    SHOW_CATALOG_SOURCE: 'showCatalogSource',
    SHOW_ASK_ADVISOR_ON_WIDGET: 'showAskAdvisorOnWidget',
    COCURICULAR_VERIFICATION_FEATURE_ID: 'cocuricular_verification',
    COURSE_STATUS_DROP_DOWN_ON_COURSE_REPORT_FEATURE_ID: 'course_status_drop_down_on_course_report',
    SHOW_XPRIZE_DATA_OPT_OUT: 'xprize_data_opt_out',
    TRANSFER_PREVIOUS_COURSES_FEATURE_ID: 'transfer_previous_courses',
    INSTITUTION_CAREERS: 'institutionCareers',
    SHOW_ASK_ADVISOR_ON_NAVIGATION: 'showAskAdvisorOnNavigation',
    SHOW_LEARNER_DASHBOARD_FEATURE_ID: 'learner_dashboard',
    CREATE_PLANNING_STREAM_FEATURE_ID: 'createPlanningStream',
    SHOW_SELF_REGISTRATION_LINK_FEATURE_ID: 'showSelfRegistrationLinkConfig',
    SHOW_ALUMNI_DATA_ON_WIDGET_FEATURE_ID: 'showAlumniDataOnWidget',
    PAYMENT_INTEGRATION: 'payment_integration',
    SHOW_PHONE_NUMBER_ON_CREATE_ACCOUNT: 'showPhoneNumberOnCreateAccountNudge',
    SHOW_NEW_RECRUITER_DASHBOARD: 'showNewRecruiterDashboard',
    CALENDAR: 'calendar',
    CAREER_RECOMMENDATION : 'career_recommendations',
    SHOW_MY_PROGRAMS_MENU : 'Show My Programs Menu',
  },
  LEGEND_FLAG_LIST: [
    'showDashboardLegend',
    'showProgressLegend'
  ],
  PROFILE_FLAG_LIST: [
    'showThumbnail',
    'updateThumbnail',
    'showCurrentInterest',
    'updateCurrentInterest',
    'showBackgroundInterest',
    'updateBackgroundInterest',
    'learnerCanUploadResume',
    'advisorCanAccessLearnerProfile'
  ],
  STUDENT_PROGRESS_FLAG_LIST: [
    'showYearOfCompletion'
  ],
  ADVISTOR_DASHBOARD_FLAG_LIST: [
    'automaticStreamShare',
    'showStudentPopover',
    'redirectStreamToProgressView',
    'lockStream',
    'advisorNotes'
  ],
  PROGRESS_VIEW_FLAG_LIST: [
    'showCreditProgress',
    'showCourseProgress',
    'showCourseProgressOnOverall'
  ],
  COURSE_SEARCH_FLAG_LIST: [
    'savedSearch',
    'showSemesterCriteria',
    'showDivisionCriteria',
    'showDepartmentCriteria',
    'showSubjectCriteria',
    'showInstructorCriteria',
    'showMajorsCriteria',
    'showUnitsCriteria',
    'showUnitsOnResult',
    'showCourseSearchFlagCriteria',
    'showDaysCriteria',
    'showTimeCriteria',
    'showGradeLevelCriteria',
    'showBlockCriteria',
    'showInstructorOnResult',
    'showSectionOnResult',
    'showCRNOnResult',
    'showMeetingDaysOnResult',
    'showMeetingTimesOnResult',
    'showEnrollmentOnResult',
    'showCreditOnResult',
    'showRoomInformationOnResult',
    'showSpecialInstructionsOnResult',
    'showGradeLevelOnResult',
    'showBlockOnResult',
    'showYearCriteria',
    'enableSearchByAnySemester'
  ],
  CATALOG_SEARCH_FLAG_LIST: [
    'showDivisionCriteria',
    'showDepartmentCriteria',
    'showSubjectCriteria'
  ],
  ADD_TO_STREAM_FLAG_LIST: [
    'showRemove'
  ],
  SCHEDULE_CHECK_FLAG_LIST: [
    'showCourseTitle',
    'showShare',
    'showPrint',
    'showCalExport',
    'showGoogleCalSync',
    'showCRN',
    'showCourseTitle',
    'showDays',
    'showTime',
    'showUnits',
    'showInstructor',
    'showBlock',
    'showGradeLevel'
  ],
  RECOMMENDATIONS_FLAG_LIST: [
    'showAlumniStreamRecommendations',
    'showAdvisorStreamRecommendations'
  ],
  EXPLORE_PROGRAM_CUSTOM_TAGS_FLAG_LIST: [
    'Werth'
  ],
  SKILL_TAGGING_FLAG_LIST: [
    'course',
    'catalog',
    'job',
    'club',
    'event'
  ],
  SKILL_TAGGING_LEVELS_FLAG_LIST: [
    'Beginner',
    'Intermediate',
    'Expert'
  ],
  SKILL_TAGGING_SOURCE_FLAG_LIST: [
    'sourceEMSI',
    'sourceBGT',
    'sourceLIGHTCAST',
    'sourceCOS'
  ],
  OTHER_SKILL_TAGGING_SOURCE_FLAG_LIST: [
    'sourceMIT',
    'sourceNACE'
  ],
  TRANSFER_PREVIOUS_COURSES_FLAG_LIST: [
    'showTransferArticulationMappingUpload',
    'showTransferredCoursesCreditProgress',
    'showTransferredCoursesOnDegreeRequirement'
  ],
  CHANNELS_FLAG_LIST: [
    'attachFile',
    'sendOnEnter',
    'showAddDirectChannelOnAll',
    'showAddDirectChannelOnCourse'
  ],
  CLEARLY_NEXT_FLAG_LIST: [
    'showAccountSubscription'
  ]
}

let featureIdsToFlags = {}
let _ = PACKAGE
let _ids = _.FEATURE_IDS
featureIdsToFlags[_ids.LEGEND_FEATURE_ID] = _.LEGEND_FLAG_LIST
featureIdsToFlags[_ids.PROFILE_FEATURE_ID] = _.PROFILE_FLAG_LIST
featureIdsToFlags[_ids.STUDENT_PROGRESS_FEATURE_ID] = _.STUDENT_PROGRESS_FLAG_LIST
featureIdsToFlags[_ids.ADVISTOR_DASHBOARD_FEATURE_ID] = _.ADVISTOR_DASHBOARD_FLAG_LIST
featureIdsToFlags[_ids.PROGRESS_VIEW_FEATURE_ID] = _.PROGRESS_VIEW_FLAG_LIST
featureIdsToFlags[_ids.COURSE_SEARCH_FEATURE_ID] = _.COURSE_SEARCH_FLAG_LIST
featureIdsToFlags[_ids.CATALOG_SEARCH_FEATURE_ID] = _.CATALOG_SEARCH_FLAG_LIST
featureIdsToFlags[_ids.ADD_TO_STREAM_FEATURE_ID] = _.ADD_TO_STREAM_FLAG_LIST
featureIdsToFlags[_ids.SCHEDULE_CHECK_FEATURE_ID] = _.SCHEDULE_CHECK_FLAG_LIST
featureIdsToFlags[_ids.STREAM_RECOMMENDATIONS_FEATURE_ID] = _.RECOMMENDATIONS_FLAG_LIST
featureIdsToFlags[_ids.TRANSFER_PREVIOUS_COURSES_FEATURE_ID] = _.TRANSFER_PREVIOUS_COURSES_FLAG_LIST
featureIdsToFlags[_ids.SKILL_TAGGING_FEATURE_ID] = _.SKILL_TAGGING_FLAG_LIST
featureIdsToFlags[_ids.SKILL_TAGGING_LEVELS_FEATURE_ID] = _.SKILL_TAGGING_LEVELS_FLAG_LIST
featureIdsToFlags[_ids.SKILL_TAGGING_SOURCE_FEATURE_ID] = _.SKILL_TAGGING_SOURCE_FLAG_LIST
featureIdsToFlags[_ids.OTHER_SKILL_TAGGING_SOURCE_FEATURE_ID] = _.OTHER_SKILL_TAGGING_SOURCE_FLAG_LIST
featureIdsToFlags[_ids.CHANNELS_FEATURE_ID] = _.CHANNELS_FLAG_LIST
featureIdsToFlags[_ids.CLEARLY_NEXT_FEATURE_ID] = _.CLEARLY_NEXT_FLAG_LIST
featureIdsToFlags[_ids.EXPLORE_PROGRAM_CUSTOM_TAGS_FEATURE_ID] = _.EXPLORE_PROGRAM_CUSTOM_TAGS_FLAG_LIST

export { PACKAGE, featureIdsToFlags }



// WEBPACK FOOTER //
// ./src/package_constants.js